import { ReceiptText } from 'lucide-react';
import { formatPrice } from '../../utils/formatters';
import { formatTaxShare } from '../../utils/euFormatters';

export default function EuTaxComparison({ data }) {
  const countries = data?.countries || [];
  if (!countries.length) return null;
  return (
    <div>
      <div className="mb-5 flex items-start gap-3">
        <div className="grid h-11 w-11 shrink-0 place-items-center rounded-[16px] bg-md-tertiary-container text-md-on-tertiary-container"><ReceiptText className="h-5 w-5" aria-hidden="true" /></div>
        <div><h2 className="text-2xl font-medium tracking-[-0.025em]">Fiscalità in Europa</h2><p className="mt-1 text-sm leading-6 text-md-on-surface-variant">Importo complessivo derivato da prezzo alla pompa − prezzo senza tasse; quota sul prezzo finale.</p></div>
      </div>
      <div className="max-h-[620px] overflow-y-auto rounded-[24px] bg-md-surface-container-low p-2">
        <div className="grid grid-cols-[minmax(0,1fr)_auto_auto] gap-3 px-3 py-2 text-xs font-bold uppercase tracking-[0.08em] text-md-on-surface-variant">
          <span>Paese</span><span>€/l</span><span>Quota</span>
        </div>
        {countries.map(country => (
          <div key={country.country} className={`grid min-h-12 grid-cols-[minmax(0,1fr)_auto_auto] items-center gap-3 rounded-[16px] px-3 py-2 text-sm ${country.country === 'IT' ? 'bg-md-primary-container text-md-on-primary-container' : ''}`}>
            <span className={`truncate ${country.country === 'IT' ? 'font-bold' : 'font-medium'}`}>{country.name}</span>
            <span className="numbers font-bold">{formatPrice(country.tax_amount)}</span>
            <span className="numbers min-w-14 text-right text-md-on-surface-variant">{formatTaxShare(country.tax_share)}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
